import type { Moment } from 'moment'
import moment from 'moment'
import { RRule } from 'rrule'

export default function enableDay({
  day,
  recurrence,
  starts_on,
}: {
  day: Date | Moment
  recurrence: string
  starts_on: string
}): boolean {
  const momentDay = moment(day)
  const options = RRule.parseString(recurrence)
  options.dtstart = new Date(starts_on)
  const rule = new RRule(options)
  const dayInUTC = new Date(Date.UTC(momentDay.year(), momentDay.month(), momentDay.date()))

  return rule.between(dayInUTC, dayInUTC, true).length > 0
}
